export const TOKEN_ERROR = 401
export const FORBIDDEN_ERROR = 403
export const NO_SIGN_UP_ERROR = 404
export const TOO_MANY_REQUESTS_ERROR = 429
